export default __webpack_public_path__ + "static/media/Manuscripts3.f7feff74.png";